import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
    getPageAnchor,
    getPageLabel,
    getPageOutboundIds,
    getPageRoute,
} from "../pageRegistry/pageRegistry";

const localizePath = (path, lang) => (lang === "en" ? path : `/${lang}${path}`);

const stablePick = (arrOrStr, seedStr) => {
    if (Array.isArray(arrOrStr)) {
        if (!arrOrStr.length) return "";
        let h = 0;
        for (let i = 0; i < seedStr.length; i++) {
            h = (h * 31 + seedStr.charCodeAt(i)) >>> 0;
        }
        return arrOrStr[h % arrOrStr.length];
    }
    return String(arrOrStr ?? "");
};

export default function SeoOutboundLinks({
                                             lang = "en",
                                             pageKey,
                                             placement = "top",
                                             ids,
                                             className = "",
                                             linkStyle,
                                         }) {
    const location = useLocation();

    const linkIds = (ids?.length ? ids : getPageOutboundIds(pageKey, placement)) || [];
    if (!linkIds.length) return null;

    const isTop = placement === "top";
    const title = getPageLabel(pageKey, placement) || "";

    const links = linkIds
        .map((id) => {
            const path = getPageRoute(id);
            if (!path) return null;

            const labelSource = getPageAnchor(id);
            const rawLabel = stablePick(labelSource, `${location.pathname}::${id}`);
            const label = rawLabel.replace(/,\s*$/, "");

            return { id, path, label };
        })
        .filter(Boolean);

    if (!links.length) return null;

    const pClass = isTop ? "mb-2" : "text-muted mt-0 mb-0";
    const topLinkClass = "seo-h1-menu-link mb-1";
    const defaultBottomLinkStyle = { color: "#6c757d" };
    const wrapClass = isTop ? "mt-0 mb-2 pb-1 border-bottom" : "mt-0 mb-0";

    return (
        <Row className={`${wrapClass} ${className}`}>
            <Col>
                {!!title &&
                    (isTop ? (
                        <p className="text-muted mb-2">{title}</p>
                    ) : (
                        <p className="text-muted fw-semibold mb-0 mt-0">{title}</p>
                    ))}

                <div className={pClass}>
                    {isTop ? (
                        links.map((l, idx) => (
                            <React.Fragment key={`${l.id}:${l.path}`}>
                                {idx > 0 && " "}
                                <Link
                                    to={localizePath(l.path, lang)}
                                    className={topLinkClass}
                                    style={linkStyle}
                                >
                                    {l.label}
                                </Link>
                            </React.Fragment>
                        ))
                    ) : (
                        <span className={`seo-links-inline ${pClass}`}>
                            {links
                                .map((l) => (
                                    <Link
                                        key={`${l.id}:${l.path}`}
                                        to={localizePath(l.path, lang)}
                                        className="seo-links-inline__link"
                                        style={linkStyle ?? defaultBottomLinkStyle}
                                    >
                                        {l.label}
                                    </Link>
                                ))
                                .reduce((acc, el, idx) => {
                                    if (idx === 0) return [el];
                                    return [...acc, <span key={`sep-${idx}`}>, </span>, el];
                                }, [])}
                        </span>
                    )}
                </div>
            </Col>
        </Row>
    );
}